<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header d-flex align-items-center">
            <h2 class="modal-title">{{ title }}</h2>
            <button
              type="button"
              class="close"
              @click="close"
              aria-label="close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <slot name="content"></slot>
          </div>
          <div class="modal-footer">
            <slot name="actions"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Título'
    },
    showModal: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      name: null
    };
  },
  methods: {
    close() {
      this.$emit('update:showModal', false);
    }
  }
};
</script>
<style lang="scss">
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;

    .modal-title {
      font-weight: 600;
      line-height: 1;
    }
  }

  .btn,
  .btn:hover,
  .btn:active,
  .btn:focus {
    border-color: #5b7823 !important;
    box-shadow: none !important;
    opacity: 1;
    font-family: 'Manrope', sans-serif;

    &.btn-primary {
      background-color: #5b7823 !important;
      font-weight: 700;
    }

    &.btn-secondary,
    .close {
      background-color: transparent !important;
      color: #5b7823 !important;
      opacity: 1;
      font-size: 20px;
    }
  }
  button.close {
    font-size: 30px;
    color: #5b7823 !important;
    opacity: 1;
  }
}

.modal-content {
  font-family: 'Manrope', sans-serif;
  color: #000;
}
</style>
